<script>
  import { Flex, FlexItem } from "@gl/design-system";
  export let amount;
  export let quota;
</script>

<Flex class="align-items-center">
  <FlexItem style="display:flex" class="mr-2">
    <progress
      {amount}
      max={quota}
      value={amount}
      style="--value-color: {amount >= quota
        ? 'var(--gl-error)'
        : 'var(--gl-primary)'}"
    ></progress>
  </FlexItem>

  <FlexItem>
    <b
      class:color-text-disabled={amount === 0}
      class:color-primary={amount < quota}
      class:color-error={amount >= quota}
    >
      {amount}
    </b>
    <span class="color-text-disabled">/</span>
    <b>{quota}</b>
  </FlexItem>
</Flex>

<style>
  progress {
    border: none;
    border-radius: 9999px;
    height: 0.5em;
    background-color: var(--gl-border);
    color: var(--value-color);
    overflow: hidden;
  }

  progress::-webkit-progress-value {
    background-color: var(--value-color);
  }

  progress::-webkit-progress-bar {
    background-color: var(--gl-border);
  }

  progress::-webkit-progress-value {
    background-color: var(--value-color);
  }

  progress::-moz-progress-bar {
    background-color: var(--value-color);
  }
</style>
